/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/dot-notation */

import { formatNumber } from '@angular/common';
import { Directive, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
    selector: '[decimalFormat]',
    providers: [NgModel],
    standalone: true,
})
export class DecimalFormatDirective implements OnInit {
	@Output() ngModelChange: EventEmitter<any> = new EventEmitter();
	@Input() decimalPlaces = 2;
	@Input() limitTo = 999999999.99;
	private el: HTMLInputElement;
	private value: any;
	constructor(private readonly elementRef: ElementRef) {
		this.el = this.elementRef.nativeElement;
	}

	ngOnInit(): void {
		setTimeout(() => {
			this.transform(this.el.value);
		}, 100);
	}

	// eslint-disable-next-line @typescript-eslint/member-ordering
	@HostListener('keydown', ['$event'])
	onKeyDown(e: KeyboardEvent): void {
		const selectionStart = e.target['selectionStart'];
		const selectionEnd = e.target['selectionEnd'];
		const isSelectAll = selectionStart === 0 && this.el.value.length === selectionEnd;
		const isHighlighted = selectionStart >= 0 && selectionEnd > selectionStart;
		const isNumber = new RegExp('^[0-9]*$').test(e?.key);

		if (isNumber) {
			const futureValue = this.el.value.substring(0, selectionStart) + e?.key + this.el.value.substring(selectionStart);
			if (!isSelectAll && parseFloat(futureValue) > this.limitTo) {
				e.preventDefault();
			} else {
				if (this.decimalPlaces > 0) {
					const arr = futureValue.split('.');
					if (!isSelectAll && arr.length > 1 && arr[1].length > this.decimalPlaces) {
						e.preventDefault();
					}
				}
			}
		} else if (e.key === 'Delete' || e.key === 'Backspace') {
			if (!isSelectAll) {
				if (!isHighlighted) {
					const futureValue =
						e.key === 'Backspace'
							? this.el.value.substring(0, selectionStart - 1) + this.el.value.substring(selectionStart)
							: this.el.value.substring(0, selectionStart) + this.el.value.substring(selectionStart + 1);
					if (parseFloat(futureValue) > this.limitTo) {
						e.preventDefault();
					}
				} else {
					const futureValue = this.el.value.substring(0, selectionStart) + this.el.value.substring(selectionEnd);
					if (parseFloat(futureValue) > this.limitTo) {
						e.preventDefault();
					}
				}
			}
			if (isSelectAll) {
				this.el.value = null;
				this.transform(this.el.value);
			}
		}
	}

	// eslint-disable-next-line @typescript-eslint/member-ordering
	@HostListener('change', ['$event.target.value'])
	onChange(value: any): void {
		this.transform(value);
	}

	/**
	 * '1.2-2' means {minIntegerDigits}.{minFractionDigits}-{maxFractionDigits}:
	 * {maxFractionDigits} is optional
	 * A minimum of 1 digit will be shown before decimal point
	 * It will show at least 2 digits after decimal point
	 * But not more than 2 digits
	 *
	 */

	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	transform(value: any): void {
		this.value = value;
		if (value && !isNaN(value)) {
			const digits = `1.${this.decimalPlaces}-${this.decimalPlaces}`;
			this.el.value = formatNumber(+this.value, 'en-US', digits);
			const formatted = this.el.value.split(',').join('');
			if (formatted.indexOf(this.value) >= 0) {
				this.value = formatted;
				this.ngModelChange.emit(this.value);
			}
		} else {
			this.value = null;
			this.ngModelChange.emit(this.value);
		}
	}
}
